import Vue from 'vue'
import configs from '@/config'
import { SimpleCache } from '@/utils/cache.utils'

let resource = null

const actions = {
  getMyPlan: {
    method: 'GET',
    url: `${configs.baseUrl}/api/pricing/my-plan/`,
  },
  getMyPlanWithStripeSnapshot: {
    method: 'GET',
    url: `${configs.baseUrl}/api/pricing/my-plan/?useSnapshotStripeInfo=true`,
  },
}

const cache = new SimpleCache()

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}
const getMyPlan = () => {
  const params = { useSnapshotStripeInfo: true }
  return resource.getMyPlan(params)
}

const getMyPlanWithCache = async ({ maxAgeInSeconds = 1 }) => {
  return cache.invoke(() => {
    return getMyPlan()
  }, {
    key: 'getMyPlan',
    maxAgeInSeconds,
  })
}

export default {
  initResource,
  getMyPlan,
  getMyPlanWithCache,
}
